import axios from 'axios'

export const state = {
  cachedEntityDescriptions: null,
  selectedEntityDescription: null,
}

export const getters = {
  cachedEntityDescriptions(state) {
    return state.cachedEntityDescriptions
  },
  selectedEntityDescription(state) {
    return state.selectedEntityDescription
  },
}

export const mutations = {
  SET_CACHE(state, entityDescriptions) {
    state.cachedEntityDescriptions = entityDescriptions
  },
  SET_SELECTED(state, entityDescription) {
    state.selectedEntityDescription = entityDescription
  },
}

export const actions = {
  selectEntityDescription({ commit, state, rootState }, { entityDescription }) {
    commit('SET_SELECTED', entityDescription)
  },

  entityDescriptionByName({ commit, state, rootState }, { name }) {
    let entityDescription = state.cachedEntityDescriptions.filter(
      (entityDescription) => entityDescription.name === name
    )[0]
    return Promise.resolve(entityDescription)
  },

  fetchEntityDescriptions({ commit, state, rootState }, { clearCache }) {
    // 1. Check if we've already fetched and cachedEntityDescriptions the user.
    const cachedEntityDescriptions = state.cachedEntityDescriptions
    if (!clearCache && cachedEntityDescriptions) {
      return Promise.resolve(cachedEntityDescriptions)
    }

    // 2. Fetch the entityDescriptions from the API and cache it in case
    // we need it again in the future.
    return axios
      .get('/api/services/app/DeviceEventEntityDescription/GetAll')
      .then((response) => {
        const entityDescriptions = response.data.items

        commit('SET_CACHE', entityDescriptions)

        return entityDescriptions
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // commit('SET_CACHE', null)
        }
        return null
      })
  },

  updateEntityDescription({ commit, dispatch, state, rootState }, { entityDescription }) {
    return axios
      .put('/api/services/app/DeviceEventEntityDescription/Update', entityDescription)
      .then((response) => {
        dispatch('fetchEntityDescriptions', { clearCache: true })
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // commit('SET_CACHE', null)
        }
        return null
      })
  },

  deleteEntityDescription({ commit, dispatch, state, rootState }, { id }) {
    return axios
      .delete('/api/services/app/entityDescription/Delete/?id=' + id + '&userId=' + '1')
      .then((response) => {
        dispatch('fetchEntityDescriptions', { clearCache: true })
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // commit('SET_CACHE', null)
        }
        return null
      })
  },
}
